// Components/AvisoTelefonosRepetidos.tsx — aviso de usuarios del equipo que comparten teléfono (round 2026-10-30).
//
// El asistente de WhatsApp identifica a quien escribe por su número: si dos personas del equipo (superadministrador,
// administrador, aseador) tienen el mismo, no sabe quién es quién y no puede responderles. El servidor ya impide crear un
// duplicado nuevo; este aviso muestra los que ya existían, con el texto acordado con el dueño, para corregirlos desde la
// lista. Recibe SOLO los grupos que la pantalla calculó con la lista que ella misma cargó (ver `utils/telefonosRepetidos.ts`),
// así que nunca nombra a nadie que quien mira no pueda ver ahí.
import React from "react";
import { Alert } from "antd";
import { fraseTelefonoRepetido, type GrupoTelefonoRepetido } from "../utils/telefonosRepetidos";

interface Props {
  /** Los grupos que comparten teléfono; sin ellos (o vacío) no se muestra nada. */
  grupos?: readonly GrupoTelefonoRepetido[];
}

const AvisoTelefonosRepetidos: React.FC<Props> = ({ grupos = [] }) => {
  if (grupos.length === 0) return null;
  return (
    <Alert
      type="warning"
      showIcon
      style={{ marginBottom: 16 }}
      message={grupos.length === 1 ? fraseTelefonoRepetido(grupos[0]) : "Hay usuarios que comparten teléfono"}
      description={
        grupos.length === 1 ? undefined : (
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {grupos.map((g) => (
              <li key={g.clave}>{fraseTelefonoRepetido(g)}</li>
            ))}
          </ul>
        )
      }
    />
  );
};

export default AvisoTelefonosRepetidos;
